module.exports = __webpack_public_path__ + "img/icon.4cc856ee.png";